"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.apiGameToNode = apiGameToNode;
exports.apiGamesToNodes = apiGamesToNodes;

var _slugify = _interopRequireDefault(require("slugify"));

function objectPropertyOrFallback(object, property, fallback) {
  if (fallback === void 0) {
    fallback = undefined;
  }

  if (!object || !object.hasOwnProperty || !property) {
    return fallback;
  }

  return object.hasOwnProperty(property) ? object[property] : fallback;
}

function getDescription(gameData) {
  var description = {
    en: null
  };

  if (!!gameData.description) {
    try {
      var parsedDescription = JSON.parse(gameData.description);

      if (parsedDescription.hasOwnProperty('text_en') && !!parsedDescription.text_en) {
        description.en = parsedDescription.text_en;
      }
    } catch (ex) {}
  }

  return description;
}

function getDetails(gameData) {
  return {
    license: objectPropertyOrFallback(gameData.details, 'license', null),
    lines: objectPropertyOrFallback(gameData.details, 'lines', 0),
    plays: objectPropertyOrFallback(gameData.details, 'plays', 0),
    reels: objectPropertyOrFallback(gameData.details, 'reels', 0),
    rtp: objectPropertyOrFallback(gameData.details, 'rtp', 0),
    wagering: objectPropertyOrFallback(gameData.details, 'wagering', 0)
  };
}

function getImageUrl(gameData, imageProperty) {
  return {
    url: objectPropertyOrFallback(gameData, imageProperty, null)
  };
}

function apiGameToNode(data, gameProviderNames) {
  var slug = data.title;
  var apiId = data.id,
      title = data.name,
      category = data.type,
      originalProvider = data.category,
      providerId = data.subcategory,
      freeRoundsSupported = data.freerounds_supported,
      hasJackpot = data.has_jackpot,
      playHref = data.hrefPlay,
      parentId = data.id_parent,
      isMobile = data.mobile,
      isNew = data["new"],
      supportsPlayForFun = data.play_for_fun_supported,
      position = data.position,
      system = data.system;
  var provider = originalProvider;

  if (gameProviderNames && gameProviderNames.hasOwnProperty(providerId)) {
    provider = gameProviderNames[providerId];
  }

  return {
    apiId: apiId,
    slug: (0, _slugify["default"])(slug),
    title: title,
    description: getDescription(data),
    category: category,
    provider: provider,
    originalProvider: originalProvider,
    providerId: providerId,
    freeRoundsSupported: freeRoundsSupported,
    hasJackpot: hasJackpot,
    playHref: playHref,
    parentId: parentId,
    isMobile: isMobile,
    isNew: isNew,
    supportsPlayForFun: supportsPlayForFun,
    position: position,
    system: system,
    images: {
      icon: getImageUrl(data, 'image'),
      background: getImageUrl(data, 'image_background'),
      filled: getImageUrl(data, 'image_filled'),
      preview: getImageUrl(data, 'image_preview')
    },
    details: getDetails(data),
    equivalentGame: ''
  };
}

function apiGamesToNodes(games, gameProviderNames) {
  var existingGameSlugs = {};
  var i = 0;
  var proccessedGames = [];

  for (var _iterator = games, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var game = _ref;
    var node = apiGameToNode(game, gameProviderNames);
    var slug = node.slug;

    if (existingGameSlugs.hasOwnProperty(slug)) {
      existingGameSlugs[slug] += 1;
      node.slug = slug + '-' + existingGameSlugs[slug];
      console.log('duplicate slug', slug, i);
    } else {
      existingGameSlugs[slug] = 0;
    }

    i++;
    proccessedGames.push(node);
  }

  return proccessedGames;
}